module.exports = __webpack_public_path__ + "static/img/1.40323e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/4/1.png
// module id = Bi3y
// module chunks = 0